import { createApiAction } from '@saucelabs/sl-util-redux';

import types from './types';
import * as api from '../../api';
import constants from './constants';

const putRecentConfigs = createApiAction(
  types.RECENT_CONFIGS_PUT,
  (payload) => api.putMetadata(constants.API_NAMESPACE, constants.RECENT_CONFIGS_KEY, payload),
);

const putSavedConfigs = createApiAction(
  types.SAVED_CONFIGS_PUT,
  (payload) => api.putMetadata(constants.API_NAMESPACE, constants.SAVED_CONFIGS_KEY, payload),
);

export default {
  putRecentConfigs,
  putSavedConfigs,
};
